import { render, staticRenderFns } from "./gds-list-grid.vue?vue&type=template&id=de51555e&scoped=true&"
import script from "./gds-list-grid.vue?vue&type=script&lang=js&"
export * from "./gds-list-grid.vue?vue&type=script&lang=js&"
import style0 from "./gds-list-grid.vue?vue&type=style&index=0&id=de51555e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de51555e",
  null
  
)

export default component.exports